import { actionArrType, columnType } from "DataTypes/Table";
import { ControlledTable } from "Components";
import { Filter2DataProps } from "DataTypes/Common";
import { FormatDropdownData } from "Utils/DataFormatter";
import { store } from "Redux/Store";
import FilterData from "Components/Filter2/Data";
import { PendingProviderType } from "DataTypes/Services/Patient.type";

export const actionArr: (
  handleChart: () => void,
  handlePatientDetails: () => void,
  handleTask: () => void,
  handleCarePlan: () => void,
  handleViewCare: () => void,
  roleId: number | null,
  data: PendingProviderType
) => actionArrType[] = (
  handleChart,
  handlePatientDetails,
  handleTask,
  handleCarePlan,
  handleViewCare,
  roleId,
  data
) => {
  return [
    ControlledTable.ActionData.userAction(handlePatientDetails),
    ControlledTable.ActionData.chartAction(handleChart),
    ControlledTable.ActionData.taskAction(handleTask),
    ...(roleId == 1 || roleId == 2
      ? [ControlledTable.ActionData.ViewCarePlanAction(handleViewCare)]
      : [
        ControlledTable.ActionData.carePlanAction(
          handleCarePlan,
          data.program == "RPM" ? "Treatment Plan" : ""
        ),
      ]),
  ];
};

export const TableCol: columnType[] = [
  ControlledTable.ColumnData.PicCol(),
  ControlledTable.ColumnData.PatientInfoCol(),
  ControlledTable.ColumnData.PracticeCol(),
  ControlledTable.ColumnData.ClinicalStaffCol(),
  ControlledTable.ColumnData.ProviderCol(),
  ControlledTable.ColumnData.ConsentGainedByCol(),
  ControlledTable.ColumnData.ProgramCol("", "text"),
  ControlledTable.ColumnData.EnrollmentDateCol(),
  ControlledTable.ColumnData.CPCompletionCol(),
  ControlledTable.ColumnData.StatusCol(),
  ControlledTable.ColumnData.ActionCol(),
];

export const FilterArr: () => Filter2DataProps[] = () => {
  const { prgDropList } = store.getState().list;
  const Arr: Filter2DataProps[] = [
    FilterData.patientName,
    FilterData.dob,
    FilterData.homeNo,
    FilterData.mobile,
    FilterData.language,
    FilterData.orgName,
    FilterData.orgLocation,
    FilterData.clinicalStaff,
    FilterData.clinicalStaffDesig,
    FilterData.provider,
    FilterData.providerDesig,
    FilterData.consentGainedBy,
    FilterData.consentGainedByDesig,
    {
      ...FilterData.prgmName,
      dropArr: FormatDropdownData(prgDropList, "id", "label", "label"),
    },
    FilterData.enrollFrom,
    FilterData.enrollTo,
    FilterData.careplanCompletionFrom,
    FilterData.careplanCompletionTo,
  ];
  return Arr;
};
